import { ModelsAccountStatus } from '@/api/generated-api'
import { URLS } from '@/configs/urls'

import {
  type ClubStatusSource,
  isAthleteStatusPagePinned,
  isClubPostApproval
} from './status'

type ClubMeResponse =
  | {
      club?: ({ id?: string } & ClubStatusSource) | null
    }
  | null
  | undefined

export function getClubDashboardHref(clubMe?: ClubMeResponse): string {
  const clubStatus = clubMe?.club?.status
  const clubId = clubMe?.club?.id

  // BAT-1104: a blocked athlete sees the application status page (BAT-597:
  // an approved one is live and goes to its cabinet below).
  if (isAthleteStatusPagePinned(clubMe?.club)) {
    return URLS.CLUB_MODERATION
  }

  if (
    clubStatus === ModelsAccountStatus.AccountStatusDraft ||
    clubStatus === ModelsAccountStatus.AccountStatusPendingDataSubmission
  ) {
    return URLS.CLUB_MODERATION
  }

  if (
    clubStatus === ModelsAccountStatus.AccountStatusPendingModeration ||
    clubStatus === ModelsAccountStatus.AccountStatusPendingAdminApprove ||
    clubStatus === ModelsAccountStatus.AccountStatusPendingApproveTransaction ||
    clubStatus === ModelsAccountStatus.AccountStatusRejected ||
    clubStatus === ModelsAccountStatus.AccountStatusChangesRequested ||
    clubStatus === ModelsAccountStatus.AccountStatusNeedsRevision
  ) {
    return URLS.CLUB_MODERATION
  }

  if (isClubPostApproval(clubStatus) && clubId) {
    return URLS.CLUB_DETAIL(clubId)
  }

  if (
    (clubStatus === ModelsAccountStatus.AccountStatusDeleted ||
      clubStatus === ModelsAccountStatus.AccountStatusBlocked) &&
    clubId
  ) {
    return URLS.CLUB_DETAIL(clubId)
  }

  return URLS.PROFILE
}
